import { render } from "./ProductRegularizationsView.vue?vue&type=template&id=7af983af&scoped=true"
import script from "./ProductRegularizationsView.vue?vue&type=script&lang=js"
export * from "./ProductRegularizationsView.vue?vue&type=script&lang=js"

import "./ProductRegularizationsView.vue?vue&type=style&index=0&id=7af983af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af983af"]])

export default __exports__